import * as ToolbarActions from "./toolbarActions";

export default ToolbarActions;



// WEBPACK FOOTER //
// ./src/actions/ToolbarActions/index.js